import React from 'react';
import './CodeCard.css';

const CodeCard = ({ code, isFlipped, showConfirmation, onConfirm, onCancel }) => {
  // Format code as X.X.X with dots between numbers
  const formattedCode = code.join('.');
  
  return (
    <div className={`code-card-container ${isFlipped ? 'flipped' : ''}`}>
      <div className="code-card-flipper">
        {/* Front of the card */}
        <div className="code-card front">
          <div className="code-card-screen">
            <div className="screen-content">
              {formattedCode}
            </div>
          </div>
          <div className="code-card-controls">
            <div className="slider-container">
              <div className="slider-track"></div>
              <div className="slider-knob"></div>
            </div>
            <div className="button-container">
              <div className="button blue"></div>
              <div className="button red"></div>
            </div>
          </div>
        </div>
        
        {/* Back of the card - Floppy Disk Design */}
        <div className="code-card back">
          {showConfirmation ? (
            <div className="card-confirmation">
              <p>Are you sure you want to show the code again?</p>
              <div className="card-confirmation-buttons">
                <button className="confirm-button" onClick={onConfirm}>Yes</button>
                <button className="cancel-button" onClick={onCancel}>No</button>
              </div>
            </div>
          ) : (
            <div className="floppy-disk">
              <div className="floppy-header">
                <div className="floppy-logo">OCP</div>
                <div className="floppy-type">MINI-DISK</div>
              </div>
              <div className="floppy-label">
                <div className="disk-number">DISK N°</div>
                <div className="disk-code">CODE</div>
              </div>
              <div className="disk-center-hole"></div>
              <div className="disk-notch"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CodeCard; 